export var OpcodesBCH;
(function (OpcodesBCH) {
    /**
     * A.K.A. `OP_FALSE` or `OP_PUSHBYTES_0`
     */
    OpcodesBCH[OpcodesBCH["OP_0"] = 0] = "OP_0";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_1"] = 1] = "OP_PUSHBYTES_1";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_2"] = 2] = "OP_PUSHBYTES_2";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_3"] = 3] = "OP_PUSHBYTES_3";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_4"] = 4] = "OP_PUSHBYTES_4";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_5"] = 5] = "OP_PUSHBYTES_5";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_6"] = 6] = "OP_PUSHBYTES_6";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_7"] = 7] = "OP_PUSHBYTES_7";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_8"] = 8] = "OP_PUSHBYTES_8";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_9"] = 9] = "OP_PUSHBYTES_9";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_10"] = 10] = "OP_PUSHBYTES_10";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_11"] = 11] = "OP_PUSHBYTES_11";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_12"] = 12] = "OP_PUSHBYTES_12";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_13"] = 13] = "OP_PUSHBYTES_13";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_14"] = 14] = "OP_PUSHBYTES_14";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_15"] = 15] = "OP_PUSHBYTES_15";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_16"] = 16] = "OP_PUSHBYTES_16";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_17"] = 17] = "OP_PUSHBYTES_17";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_18"] = 18] = "OP_PUSHBYTES_18";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_19"] = 19] = "OP_PUSHBYTES_19";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_20"] = 20] = "OP_PUSHBYTES_20";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_21"] = 21] = "OP_PUSHBYTES_21";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_22"] = 22] = "OP_PUSHBYTES_22";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_23"] = 23] = "OP_PUSHBYTES_23";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_24"] = 24] = "OP_PUSHBYTES_24";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_25"] = 25] = "OP_PUSHBYTES_25";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_26"] = 26] = "OP_PUSHBYTES_26";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_27"] = 27] = "OP_PUSHBYTES_27";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_28"] = 28] = "OP_PUSHBYTES_28";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_29"] = 29] = "OP_PUSHBYTES_29";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_30"] = 30] = "OP_PUSHBYTES_30";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_31"] = 31] = "OP_PUSHBYTES_31";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_32"] = 32] = "OP_PUSHBYTES_32";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_33"] = 33] = "OP_PUSHBYTES_33";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_34"] = 34] = "OP_PUSHBYTES_34";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_35"] = 35] = "OP_PUSHBYTES_35";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_36"] = 36] = "OP_PUSHBYTES_36";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_37"] = 37] = "OP_PUSHBYTES_37";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_38"] = 38] = "OP_PUSHBYTES_38";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_39"] = 39] = "OP_PUSHBYTES_39";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_40"] = 40] = "OP_PUSHBYTES_40";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_41"] = 41] = "OP_PUSHBYTES_41";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_42"] = 42] = "OP_PUSHBYTES_42";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_43"] = 43] = "OP_PUSHBYTES_43";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_44"] = 44] = "OP_PUSHBYTES_44";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_45"] = 45] = "OP_PUSHBYTES_45";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_46"] = 46] = "OP_PUSHBYTES_46";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_47"] = 47] = "OP_PUSHBYTES_47";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_48"] = 48] = "OP_PUSHBYTES_48";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_49"] = 49] = "OP_PUSHBYTES_49";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_50"] = 50] = "OP_PUSHBYTES_50";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_51"] = 51] = "OP_PUSHBYTES_51";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_52"] = 52] = "OP_PUSHBYTES_52";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_53"] = 53] = "OP_PUSHBYTES_53";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_54"] = 54] = "OP_PUSHBYTES_54";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_55"] = 55] = "OP_PUSHBYTES_55";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_56"] = 56] = "OP_PUSHBYTES_56";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_57"] = 57] = "OP_PUSHBYTES_57";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_58"] = 58] = "OP_PUSHBYTES_58";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_59"] = 59] = "OP_PUSHBYTES_59";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_60"] = 60] = "OP_PUSHBYTES_60";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_61"] = 61] = "OP_PUSHBYTES_61";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_62"] = 62] = "OP_PUSHBYTES_62";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_63"] = 63] = "OP_PUSHBYTES_63";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_64"] = 64] = "OP_PUSHBYTES_64";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_65"] = 65] = "OP_PUSHBYTES_65";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_66"] = 66] = "OP_PUSHBYTES_66";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_67"] = 67] = "OP_PUSHBYTES_67";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_68"] = 68] = "OP_PUSHBYTES_68";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_69"] = 69] = "OP_PUSHBYTES_69";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_70"] = 70] = "OP_PUSHBYTES_70";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_71"] = 71] = "OP_PUSHBYTES_71";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_72"] = 72] = "OP_PUSHBYTES_72";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_73"] = 73] = "OP_PUSHBYTES_73";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_74"] = 74] = "OP_PUSHBYTES_74";
    OpcodesBCH[OpcodesBCH["OP_PUSHBYTES_75"] = 75] = "OP_PUSHBYTES_75";
    OpcodesBCH[OpcodesBCH["OP_PUSHDATA_1"] = 76] = "OP_PUSHDATA_1";
    OpcodesBCH[OpcodesBCH["OP_PUSHDATA_2"] = 77] = "OP_PUSHDATA_2";
    OpcodesBCH[OpcodesBCH["OP_PUSHDATA_4"] = 78] = "OP_PUSHDATA_4";
    OpcodesBCH[OpcodesBCH["OP_1NEGATE"] = 79] = "OP_1NEGATE";
    OpcodesBCH[OpcodesBCH["OP_RESERVED"] = 80] = "OP_RESERVED";
    /**
     * A.K.A. `OP_TRUE`
     */
    OpcodesBCH[OpcodesBCH["OP_1"] = 81] = "OP_1";
    OpcodesBCH[OpcodesBCH["OP_2"] = 82] = "OP_2";
    OpcodesBCH[OpcodesBCH["OP_3"] = 83] = "OP_3";
    OpcodesBCH[OpcodesBCH["OP_4"] = 84] = "OP_4";
    OpcodesBCH[OpcodesBCH["OP_5"] = 85] = "OP_5";
    OpcodesBCH[OpcodesBCH["OP_6"] = 86] = "OP_6";
    OpcodesBCH[OpcodesBCH["OP_7"] = 87] = "OP_7";
    OpcodesBCH[OpcodesBCH["OP_8"] = 88] = "OP_8";
    OpcodesBCH[OpcodesBCH["OP_9"] = 89] = "OP_9";
    OpcodesBCH[OpcodesBCH["OP_10"] = 90] = "OP_10";
    OpcodesBCH[OpcodesBCH["OP_11"] = 91] = "OP_11";
    OpcodesBCH[OpcodesBCH["OP_12"] = 92] = "OP_12";
    OpcodesBCH[OpcodesBCH["OP_13"] = 93] = "OP_13";
    OpcodesBCH[OpcodesBCH["OP_14"] = 94] = "OP_14";
    OpcodesBCH[OpcodesBCH["OP_15"] = 95] = "OP_15";
    OpcodesBCH[OpcodesBCH["OP_16"] = 96] = "OP_16";
    OpcodesBCH[OpcodesBCH["OP_NOP"] = 97] = "OP_NOP";
    OpcodesBCH[OpcodesBCH["OP_VER"] = 98] = "OP_VER";
    OpcodesBCH[OpcodesBCH["OP_IF"] = 99] = "OP_IF";
    OpcodesBCH[OpcodesBCH["OP_NOTIF"] = 100] = "OP_NOTIF";
    OpcodesBCH[OpcodesBCH["OP_VERIF"] = 101] = "OP_VERIF";
    OpcodesBCH[OpcodesBCH["OP_VERNOTIF"] = 102] = "OP_VERNOTIF";
    OpcodesBCH[OpcodesBCH["OP_ELSE"] = 103] = "OP_ELSE";
    OpcodesBCH[OpcodesBCH["OP_ENDIF"] = 104] = "OP_ENDIF";
    OpcodesBCH[OpcodesBCH["OP_VERIFY"] = 105] = "OP_VERIFY";
    OpcodesBCH[OpcodesBCH["OP_RETURN"] = 106] = "OP_RETURN";
    OpcodesBCH[OpcodesBCH["OP_TOALTSTACK"] = 107] = "OP_TOALTSTACK";
    OpcodesBCH[OpcodesBCH["OP_FROMALTSTACK"] = 108] = "OP_FROMALTSTACK";
    OpcodesBCH[OpcodesBCH["OP_2DROP"] = 109] = "OP_2DROP";
    OpcodesBCH[OpcodesBCH["OP_2DUP"] = 110] = "OP_2DUP";
    OpcodesBCH[OpcodesBCH["OP_3DUP"] = 111] = "OP_3DUP";
    OpcodesBCH[OpcodesBCH["OP_2OVER"] = 112] = "OP_2OVER";
    OpcodesBCH[OpcodesBCH["OP_2ROT"] = 113] = "OP_2ROT";
    OpcodesBCH[OpcodesBCH["OP_2SWAP"] = 114] = "OP_2SWAP";
    OpcodesBCH[OpcodesBCH["OP_IFDUP"] = 115] = "OP_IFDUP";
    OpcodesBCH[OpcodesBCH["OP_DEPTH"] = 116] = "OP_DEPTH";
    OpcodesBCH[OpcodesBCH["OP_DROP"] = 117] = "OP_DROP";
    OpcodesBCH[OpcodesBCH["OP_DUP"] = 118] = "OP_DUP";
    OpcodesBCH[OpcodesBCH["OP_NIP"] = 119] = "OP_NIP";
    OpcodesBCH[OpcodesBCH["OP_OVER"] = 120] = "OP_OVER";
    OpcodesBCH[OpcodesBCH["OP_PICK"] = 121] = "OP_PICK";
    OpcodesBCH[OpcodesBCH["OP_ROLL"] = 122] = "OP_ROLL";
    OpcodesBCH[OpcodesBCH["OP_ROT"] = 123] = "OP_ROT";
    OpcodesBCH[OpcodesBCH["OP_SWAP"] = 124] = "OP_SWAP";
    OpcodesBCH[OpcodesBCH["OP_TUCK"] = 125] = "OP_TUCK";
    OpcodesBCH[OpcodesBCH["OP_CAT"] = 126] = "OP_CAT";
    OpcodesBCH[OpcodesBCH["OP_SPLIT"] = 127] = "OP_SPLIT";
    OpcodesBCH[OpcodesBCH["OP_NUM2BIN"] = 128] = "OP_NUM2BIN";
    OpcodesBCH[OpcodesBCH["OP_BIN2NUM"] = 129] = "OP_BIN2NUM";
    OpcodesBCH[OpcodesBCH["OP_SIZE"] = 130] = "OP_SIZE";
    OpcodesBCH[OpcodesBCH["OP_INVERT"] = 131] = "OP_INVERT";
    OpcodesBCH[OpcodesBCH["OP_AND"] = 132] = "OP_AND";
    OpcodesBCH[OpcodesBCH["OP_OR"] = 133] = "OP_OR";
    OpcodesBCH[OpcodesBCH["OP_XOR"] = 134] = "OP_XOR";
    OpcodesBCH[OpcodesBCH["OP_EQUAL"] = 135] = "OP_EQUAL";
    OpcodesBCH[OpcodesBCH["OP_EQUALVERIFY"] = 136] = "OP_EQUALVERIFY";
    OpcodesBCH[OpcodesBCH["OP_RESERVED1"] = 137] = "OP_RESERVED1";
    OpcodesBCH[OpcodesBCH["OP_RESERVED2"] = 138] = "OP_RESERVED2";
    OpcodesBCH[OpcodesBCH["OP_1ADD"] = 139] = "OP_1ADD";
    OpcodesBCH[OpcodesBCH["OP_1SUB"] = 140] = "OP_1SUB";
    OpcodesBCH[OpcodesBCH["OP_2MUL"] = 141] = "OP_2MUL";
    OpcodesBCH[OpcodesBCH["OP_2DIV"] = 142] = "OP_2DIV";
    OpcodesBCH[OpcodesBCH["OP_NEGATE"] = 143] = "OP_NEGATE";
    OpcodesBCH[OpcodesBCH["OP_ABS"] = 144] = "OP_ABS";
    OpcodesBCH[OpcodesBCH["OP_NOT"] = 145] = "OP_NOT";
    OpcodesBCH[OpcodesBCH["OP_0NOTEQUAL"] = 146] = "OP_0NOTEQUAL";
    OpcodesBCH[OpcodesBCH["OP_ADD"] = 147] = "OP_ADD";
    OpcodesBCH[OpcodesBCH["OP_SUB"] = 148] = "OP_SUB";
    OpcodesBCH[OpcodesBCH["OP_MUL"] = 149] = "OP_MUL";
    OpcodesBCH[OpcodesBCH["OP_DIV"] = 150] = "OP_DIV";
    OpcodesBCH[OpcodesBCH["OP_MOD"] = 151] = "OP_MOD";
    OpcodesBCH[OpcodesBCH["OP_LSHIFT"] = 152] = "OP_LSHIFT";
    OpcodesBCH[OpcodesBCH["OP_RSHIFT"] = 153] = "OP_RSHIFT";
    OpcodesBCH[OpcodesBCH["OP_BOOLAND"] = 154] = "OP_BOOLAND";
    OpcodesBCH[OpcodesBCH["OP_BOOLOR"] = 155] = "OP_BOOLOR";
    OpcodesBCH[OpcodesBCH["OP_NUMEQUAL"] = 156] = "OP_NUMEQUAL";
    OpcodesBCH[OpcodesBCH["OP_NUMEQUALVERIFY"] = 157] = "OP_NUMEQUALVERIFY";
    OpcodesBCH[OpcodesBCH["OP_NUMNOTEQUAL"] = 158] = "OP_NUMNOTEQUAL";
    OpcodesBCH[OpcodesBCH["OP_LESSTHAN"] = 159] = "OP_LESSTHAN";
    OpcodesBCH[OpcodesBCH["OP_GREATERTHAN"] = 160] = "OP_GREATERTHAN";
    OpcodesBCH[OpcodesBCH["OP_LESSTHANOREQUAL"] = 161] = "OP_LESSTHANOREQUAL";
    OpcodesBCH[OpcodesBCH["OP_GREATERTHANOREQUAL"] = 162] = "OP_GREATERTHANOREQUAL";
    OpcodesBCH[OpcodesBCH["OP_MIN"] = 163] = "OP_MIN";
    OpcodesBCH[OpcodesBCH["OP_MAX"] = 164] = "OP_MAX";
    OpcodesBCH[OpcodesBCH["OP_WITHIN"] = 165] = "OP_WITHIN";
    OpcodesBCH[OpcodesBCH["OP_RIPEMD160"] = 166] = "OP_RIPEMD160";
    OpcodesBCH[OpcodesBCH["OP_SHA1"] = 167] = "OP_SHA1";
    OpcodesBCH[OpcodesBCH["OP_SHA256"] = 168] = "OP_SHA256";
    OpcodesBCH[OpcodesBCH["OP_HASH160"] = 169] = "OP_HASH160";
    OpcodesBCH[OpcodesBCH["OP_HASH256"] = 170] = "OP_HASH256";
    OpcodesBCH[OpcodesBCH["OP_CODESEPARATOR"] = 171] = "OP_CODESEPARATOR";
    OpcodesBCH[OpcodesBCH["OP_CHECKSIG"] = 172] = "OP_CHECKSIG";
    OpcodesBCH[OpcodesBCH["OP_CHECKSIGVERIFY"] = 173] = "OP_CHECKSIGVERIFY";
    OpcodesBCH[OpcodesBCH["OP_CHECKMULTISIG"] = 174] = "OP_CHECKMULTISIG";
    OpcodesBCH[OpcodesBCH["OP_CHECKMULTISIGVERIFY"] = 175] = "OP_CHECKMULTISIGVERIFY";
    OpcodesBCH[OpcodesBCH["OP_NOP1"] = 176] = "OP_NOP1";
    /**
     * Previously `OP_NOP2`
     */
    OpcodesBCH[OpcodesBCH["OP_CHECKLOCKTIMEVERIFY"] = 177] = "OP_CHECKLOCKTIMEVERIFY";
    /**
     * Previously `OP_NOP2`
     */
    OpcodesBCH[OpcodesBCH["OP_CHECKSEQUENCEVERIFY"] = 178] = "OP_CHECKSEQUENCEVERIFY";
    OpcodesBCH[OpcodesBCH["OP_NOP4"] = 179] = "OP_NOP4";
    OpcodesBCH[OpcodesBCH["OP_NOP5"] = 180] = "OP_NOP5";
    OpcodesBCH[OpcodesBCH["OP_NOP6"] = 181] = "OP_NOP6";
    OpcodesBCH[OpcodesBCH["OP_NOP7"] = 182] = "OP_NOP7";
    OpcodesBCH[OpcodesBCH["OP_NOP8"] = 183] = "OP_NOP8";
    OpcodesBCH[OpcodesBCH["OP_NOP9"] = 184] = "OP_NOP9";
    OpcodesBCH[OpcodesBCH["OP_NOP10"] = 185] = "OP_NOP10";
    /**
     * Previously `OP_UNKNOWN186`
     */
    OpcodesBCH[OpcodesBCH["OP_CHECKDATASIG"] = 186] = "OP_CHECKDATASIG";
    /**
     * Previously `OP_UNKNOWN187`
     */
    OpcodesBCH[OpcodesBCH["OP_CHECKDATASIGVERIFY"] = 187] = "OP_CHECKDATASIGVERIFY";
    /**
     * A.K.A. `FIRST_UNDEFINED_OP_VALUE`
     */
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN188"] = 188] = "OP_UNKNOWN188";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN189"] = 189] = "OP_UNKNOWN189";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN190"] = 190] = "OP_UNKNOWN190";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN191"] = 191] = "OP_UNKNOWN191";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN192"] = 192] = "OP_UNKNOWN192";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN193"] = 193] = "OP_UNKNOWN193";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN194"] = 194] = "OP_UNKNOWN194";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN195"] = 195] = "OP_UNKNOWN195";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN196"] = 196] = "OP_UNKNOWN196";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN197"] = 197] = "OP_UNKNOWN197";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN198"] = 198] = "OP_UNKNOWN198";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN199"] = 199] = "OP_UNKNOWN199";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN200"] = 200] = "OP_UNKNOWN200";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN201"] = 201] = "OP_UNKNOWN201";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN202"] = 202] = "OP_UNKNOWN202";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN203"] = 203] = "OP_UNKNOWN203";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN204"] = 204] = "OP_UNKNOWN204";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN205"] = 205] = "OP_UNKNOWN205";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN206"] = 206] = "OP_UNKNOWN206";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN207"] = 207] = "OP_UNKNOWN207";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN208"] = 208] = "OP_UNKNOWN208";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN209"] = 209] = "OP_UNKNOWN209";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN210"] = 210] = "OP_UNKNOWN210";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN211"] = 211] = "OP_UNKNOWN211";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN212"] = 212] = "OP_UNKNOWN212";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN213"] = 213] = "OP_UNKNOWN213";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN214"] = 214] = "OP_UNKNOWN214";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN215"] = 215] = "OP_UNKNOWN215";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN216"] = 216] = "OP_UNKNOWN216";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN217"] = 217] = "OP_UNKNOWN217";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN218"] = 218] = "OP_UNKNOWN218";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN219"] = 219] = "OP_UNKNOWN219";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN220"] = 220] = "OP_UNKNOWN220";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN221"] = 221] = "OP_UNKNOWN221";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN222"] = 222] = "OP_UNKNOWN222";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN223"] = 223] = "OP_UNKNOWN223";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN224"] = 224] = "OP_UNKNOWN224";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN225"] = 225] = "OP_UNKNOWN225";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN226"] = 226] = "OP_UNKNOWN226";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN227"] = 227] = "OP_UNKNOWN227";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN228"] = 228] = "OP_UNKNOWN228";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN229"] = 229] = "OP_UNKNOWN229";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN230"] = 230] = "OP_UNKNOWN230";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN231"] = 231] = "OP_UNKNOWN231";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN232"] = 232] = "OP_UNKNOWN232";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN233"] = 233] = "OP_UNKNOWN233";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN234"] = 234] = "OP_UNKNOWN234";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN235"] = 235] = "OP_UNKNOWN235";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN236"] = 236] = "OP_UNKNOWN236";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN237"] = 237] = "OP_UNKNOWN237";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN238"] = 238] = "OP_UNKNOWN238";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN239"] = 239] = "OP_UNKNOWN239";
    /**
     * A.K.A. `OP_PREFIX_BEGIN`
     */
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN240"] = 240] = "OP_UNKNOWN240";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN241"] = 241] = "OP_UNKNOWN241";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN242"] = 242] = "OP_UNKNOWN242";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN243"] = 243] = "OP_UNKNOWN243";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN244"] = 244] = "OP_UNKNOWN244";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN245"] = 245] = "OP_UNKNOWN245";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN246"] = 246] = "OP_UNKNOWN246";
    /**
     * A.K.A. `OP_PREFIX_END`
     */
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN247"] = 247] = "OP_UNKNOWN247";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN248"] = 248] = "OP_UNKNOWN248";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN249"] = 249] = "OP_UNKNOWN249";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN250"] = 250] = "OP_UNKNOWN250";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN251"] = 251] = "OP_UNKNOWN251";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN252"] = 252] = "OP_UNKNOWN252";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN253"] = 253] = "OP_UNKNOWN253";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN254"] = 254] = "OP_UNKNOWN254";
    OpcodesBCH[OpcodesBCH["OP_UNKNOWN255"] = 255] = "OP_UNKNOWN255";
})(OpcodesBCH || (OpcodesBCH = {}));
export var OpcodeAlternateNamesBCH;
(function (OpcodeAlternateNamesBCH) {
    /**
     * A.K.A. `OP_0`
     */
    OpcodeAlternateNamesBCH[OpcodeAlternateNamesBCH["OP_FALSE"] = 0] = "OP_FALSE";
    /**
     * A.K.A. `OP_0`
     */
    OpcodeAlternateNamesBCH[OpcodeAlternateNamesBCH["OP_PUSHBYTES_0"] = 0] = "OP_PUSHBYTES_0";
    /**
     * A.K.A. `OP_1`
     */
    OpcodeAlternateNamesBCH[OpcodeAlternateNamesBCH["OP_TRUE"] = 81] = "OP_TRUE";
    /**
     * A.K.A. `OP_CHECKLOCKTIMEVERIFY`
     */
    OpcodeAlternateNamesBCH[OpcodeAlternateNamesBCH["OP_NOP2"] = 177] = "OP_NOP2";
    /**
     * A.K.A. `OP_CHECKSEQUENCEVERIFY`
     */
    OpcodeAlternateNamesBCH[OpcodeAlternateNamesBCH["OP_NOP3"] = 178] = "OP_NOP3";
    /**
     * A.K.A. `OP_CHECKDATASIG`
     */
    OpcodeAlternateNamesBCH[OpcodeAlternateNamesBCH["OP_UNKNOWN186"] = 186] = "OP_UNKNOWN186";
    /**
     * A.K.A. `OP_CHECKDATASIGVERIFY`
     */
    OpcodeAlternateNamesBCH[OpcodeAlternateNamesBCH["OP_UNKNOWN187"] = 187] = "OP_UNKNOWN187";
    /**
     * A.K.A. `OP_UNKNOWN188`
     */
    OpcodeAlternateNamesBCH[OpcodeAlternateNamesBCH["FIRST_UNDEFINED_OP_VALUE"] = 188] = "FIRST_UNDEFINED_OP_VALUE";
    /**
     * A.K.A. `OP_UNKNOWN240`. Some implementations have reserved opcodes
     * `0xf0` through `0xf7` for a future range of multi-byte opcodes, though none
     * are yet available on the network.
     */
    OpcodeAlternateNamesBCH[OpcodeAlternateNamesBCH["OP_PREFIX_BEGIN"] = 240] = "OP_PREFIX_BEGIN";
    /**
     * A.K.A. `OP_UNKNOWN247`. Some implementations have reserved opcodes
     * `0xf0` through `0xf7` for a future range of multi-byte opcodes, though none
     * are yet available on the network.
     */
    OpcodeAlternateNamesBCH[OpcodeAlternateNamesBCH["OP_PREFIX_END"] = 247] = "OP_PREFIX_END";
    /**
     * `OP_SMALLINTEGER` is used internally for template matching in the C++
     * implementation. When found on the network, it is `OP_UNKNOWN250`.
     */
    OpcodeAlternateNamesBCH[OpcodeAlternateNamesBCH["OP_SMALLINTEGER"] = 250] = "OP_SMALLINTEGER";
    /**
     * `OP_PUBKEYS` is used internally for template matching in the C++
     * implementation. When found on the network, it is `OP_UNKNOWN251`.
     */
    OpcodeAlternateNamesBCH[OpcodeAlternateNamesBCH["OP_PUBKEYS"] = 251] = "OP_PUBKEYS";
    /**
     * `OP_PUBKEYHASH` is used internally for template matching in the C++
     * implementation. When found on the network, it is `OP_UNKNOWN253`.
     */
    OpcodeAlternateNamesBCH[OpcodeAlternateNamesBCH["OP_PUBKEYHASH"] = 253] = "OP_PUBKEYHASH";
    /**
     * `OP_PUBKEY` is used internally for template matching in the C++
     * implementation. When found on the network, it is `OP_UNKNOWN254`.
     */
    OpcodeAlternateNamesBCH[OpcodeAlternateNamesBCH["OP_PUBKEY"] = 254] = "OP_PUBKEY";
    /**
     * `OP_INVALIDOPCODE` is described as such for testing in the C++
     * implementation. When found on the network, it is `OP_UNKNOWN255`.
     */
    OpcodeAlternateNamesBCH[OpcodeAlternateNamesBCH["OP_INVALIDOPCODE"] = 255] = "OP_INVALIDOPCODE";
})(OpcodeAlternateNamesBCH || (OpcodeAlternateNamesBCH = {}));
//# sourceMappingURL=data:application/json;base64,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